import { useCallback } from 'react';
import EntryDataServices from '../../../services/EntryDataServices';
import { transformRowsToJson } from '../utils/entryDataUtils';
import {LogsServices} from "../../../services/LogsServices";

/**
 * Custom hook for managing data save operations
 * @param {string} initialHeader - The initial header for the data
 * @param {Array} cities - Cities array
 * @param {Array} completeCities - Complete cities data
 * @param {Array} completeSpecialties - Complete specialties data
 * @returns {Object} - Contains save handler
 */
export const useDataSave = (initialHeader, cities, completeCities, completeSpecialties) => {
  const handleSave = useCallback((updatedRows) => {
    try {
      const json = transformRowsToJson(updatedRows, cities, completeCities, completeSpecialties);
      EntryDataServices.postAttributes(initialHeader, json);
      LogsServices.postLog(`Ação: Dados salvos na etapa ${initialHeader}`);
    } catch (error) {
      console.error('Error saving data:', error);
    }
  }, [initialHeader, cities, completeCities, completeSpecialties]);

  return {
    handleSave
  };
};
